import {Fragment, useEffect, useState} from 'react';

import XMLViewer from 'react-xml-viewer'

import {Dialog} from 'primereact/dialog';

import {useDataTable} from '../../../shared/hooks/DataTable';

import {MGateWayService} from '../MGateWayService';

import {LoadingService} from '../../../AppLoading';

export const TransferLogs = (props) => {

  const {type, idAction, version, setCanRollback, sendTaxStatus} = props;
  const {showInvoiceInfo, rows, heightCalc} = props;
  const [perPageOptions, setPerPageOptions ]= useState([50, 100, 200,300]);
  const [requiredParams, setRequiredParams] = useState(null);
  const [xml, setXml] = useState(null);
  const [displayXml, setDisplayXml] = useState(null);
  const [pdf, setPdf] = useState(null);
  const [displayPdf, setDisplayPdf] = useState(null);

  const mltDieps = [
    {value: '-1', label: '-1 - Lỗi chưa xác định'},
    {value: '102', label: '102 - CQT tiếp nhận tờ khai'},
    {value: '103', label: '103 - CQT duyệt tờ khai'},
    {value: '204', label: '204 - CQT kiểm tra dữ liệu'},
    {value: '202', label: '202 - CQT cấp mã hóa đơn'},
    {value: '301', label: '301 - CQT duyệt thông báo sai sót'},
    {value: '999', label: '999 - CQT đã nhận được thông điệp'}
  ];

  const columns: any = [];

  if (showInvoiceInfo) {
    columns.push(
      {field: 'invoiceSerial', header: 'Ký hiệu', width: 120, matchMode: 'contains'},
      {field: 'invoiceNumber', header: 'Số hoá đơn', width: 120, matchMode: 'contains'}
    );
  }

  columns.push(
    {field: 'mtdtChieu', header: 'Mã thông điệp', minWidth: 160},
    {field: 'mltDiep', header: 'Loại thông điệp', minWidth: 160, matchMode: 'contains', filterType: 'dropdown', filterOptions: mltDieps, dataType: 'fromFilterOptions'},
    {field: 'receivedDate', header: 'Thời gian nhận', width: 160, dataType: 'date-time'},
    {
      field: 'errorCode', header: 'Trạng thái', width: 120, dataType: 'custom', customCell(rowData: any): any {
        if (!rowData.errorCode || rowData.errorCode === '0') {
          return <span className={`ss04-status invoice-status-0`}>Thành công</span>;
        }
        return <span className={`ss04-status invoice-status-1`}>Có lỗi</span>;
      }
    },
    {
      field: 'errorDesc', header: 'Mô tả lỗi', minWidth: 150, dataType: 'custom', customCell(rowData: any): any {
        if (!rowData.errorCode || rowData.errorCode === '0') {
          return '';
        }
        return rowData.errorCode + ' - ' + rowData.errorDesc;
      }
    },
    {
      field: '', header: 'Thao tác', width: 80, sortable: false, dataType: 'custom', customCell(rowData: any): any {
        if (!rowData.mltDiep || rowData.mltDiep === '999') {
          return (
            <div>
              <i className="pi pi-download mr-3" onClick={() => downloadXml(rowData)}></i>
              <i className="pi pi-eye mr-3" onClick={() => viewXml(rowData)}></i>
              <i className="pi pi-print"></i>
            </div>
          );
      } else {
        return (
          <div>
            <i className="pi pi-download mr-3" onClick={() => downloadXml(rowData)}></i>
            <i className="pi pi-eye mr-3" onClick={() => viewXml(rowData)}></i>
            <i className="pi pi-print" onClick={() => viewPdf(rowData)}></i>
          </div>
        );
      }
      }, style: {justifyContent: 'center'}
    }
  );

  useEffect(() => {
    setRequiredParams({
      type,
      sorting: 'receivedDate',
      sortType: 'DESCEND',
      idAction,
      sendTaxStatus
    });
  }, [type, idAction, version, sendTaxStatus]);

  const {render: renderDataTable} = useDataTable({
    columns,
    indexColumnWidth: 40,
    getList: (params) => {
      return MGateWayService.getList(params).then(data => {
        if (setCanRollback) {
          setCanRollback(data && data.totalCount === 0);
        }
        return data;
      });
    },
    rows,
    heightCalc,
    requiredParams,
    selectionMode: 'single',
    perPageOptions
  });

  const downloadXml = (rowData) => {
    MGateWayService.downloadXml(rowData.id).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `${rowData['mtdtChieu']}.xml`;
      link.click();
    });
  }

  const viewXml = (rowData) => {
    MGateWayService.getXml(rowData.id).then(data => {
      setXml(data);
      setDisplayXml(true);
    });
  }

  const viewPdf = (rowData) => {
    setPdf(MGateWayService.getPdfUrl(rowData.id));
    setDisplayPdf(true);

    LoadingService.start();
  }

  const onIframeLoad = () => {
    LoadingService.stop();
  }

  return (
    <Fragment>
      {renderDataTable()}
      <Dialog header="Xml" visible={displayXml} style={{width: '60rem'}} position="top"
              onHide={() => setDisplayXml(false)}>
        {xml &&
					<XMLViewer xml={xml}/>
        }
      </Dialog>
      <Dialog header="Pdf" visible={displayPdf} style={{width: '80rem'}} position="top"
              onHide={() => setDisplayPdf(false)}>
        {pdf &&
					<iframe className="template-preview" src={pdf} title="pdf-preview" onLoad={onIframeLoad}/>
        }
      </Dialog>
    </Fragment>
  );
}